import script from "./permitted-occupiers.vue?vue&type=script&setup=true&lang=ts"
export * from "./permitted-occupiers.vue?vue&type=script&setup=true&lang=ts"

import "./permitted-occupiers.vue?vue&type=style&index=0&id=32235550&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32235550"]])

export default __exports__